<template>
    <div class="table-wrapper" style="padding-top: 30px">
        <div class="fchart-wrapper" style="margin-bottom: 24px;">
            <div class="aFlex fchart-top">
                <span class="ft-bold">请选择统计时间：</span>
                <DatePicker style="width: 180px;" type="month" placement="bottom-end" transfer placeholder="请选择" :value="countDate" @on-change="onCountDate" ></DatePicker>
            </div>
            <Row :gutter="24">
                <Col span="12">
                    <div class="fchart-box" style="margin-bottom: 0">
                        <div class="aFlex fchart-box-top">
                            <span class="ft-bold">培训情况分析</span>
                            <!--<span class="ft-gray" style="margin-left: 10px">默认统计系统日期上个月</span>-->
                            <!--<Button style="margin-left: auto" type="primary" >查看全部</Button>-->
                        </div>
                        <div class="fchart-bi" ref="trainPie">培训情况分析</div>
                    </div>
                </Col>
                <Col span="12">
                    <div class="fchart-box" style="margin-bottom: 0">
                        <div class="aFlex fchart-box-top">
                            <div class="main-credit-item"
                                 :class="{active:isTraining===1}"
                                 @click="handleTrain(1)">已培训项目</div>
                            <div class="main-credit-item" :class="{active:isTraining===0}"
                                 @click="handleTrain(0)">未培训项目</div>
                        </div>
                        <div class="fchart-bi" style="padding: 12px">
                            <Table :loading="loading_t" :columns="tColumns" :data="trainData"
                                 size="small"  border :show-header="true" highlight-row>
                                <template slot-scope="{ row, index }" slot="projectName">
                                    <span class="ft-bold-blue">{{row.projectName}}</span>
                                </template>
                            </Table>
                            <!--<div class="aFlex" style="margin-top: 10px">-->
                                <!--<Page style="margin-left: auto" size="small"-->
                                      <!--:current="page_t" :total="total_t"-->
                                      <!--@on-change="changePage_t"-->
                                      <!--prev-text="上一页" next-text="下一页" />-->
                                <!--<Button style="margin-left: 15px" type="primary" size="small">查看全部</Button>-->
                            <!--</div>-->
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="fchart-box">
            <div class="aFlex fchart-box-top">
                <span class="ft-bold">培训情况开展统计</span>
                <div class="fchart-top-right aFlex">
                    <div style="width: 150px">
                        <DatePicker type="year" placement="bottom-end" placeholder="请选择年份"
                                    :value="dateYear" :clearable="false"
                                    @on-change="onDateYear" ></DatePicker>
                    </div>
                </div>
            </div>
            <div class="fchart-bi" ref="trainLine">培训情况开展统计</div>
        </div>


    </div>
</template>
<style scoped>
    .main-credit-item{
        padding: 0 10px;
        /* padding-top: 5px; */
        line-height: 50px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        transition: color .3s ease-in-out;
    }
    .main-credit-item.active{
        color: #0099FF;
        border-bottom-color: #0099FF;
    }
</style>
<script>
    import {mapState} from 'vuex';
    export default {
        data(){
            return {
                // 已培训 未培训
                isTraining:1,
                loading_t:false,
                page_t:1,
                total_t:0,
                tColumns:[
                    {
                        title: '项目名称',
                        key: 'projectName',
                        minWidth:100
                    },
                    {
                        title: '培训类型',
                        key: 'eduTypeStr'
                    },
                    {
                        title: '在册人数',
                        key: 'prjRegisteredNumber'
                    },
                    {
                        title: '培训人数',
                        key: 'eduNumber'
                    },
                ],
                trainData:[],

                // 培训情况分析
                trainPie:null,
                //  培训情况统计
                trainLine:null,
                // 选择年
                dateYear:'',
                // 统计时间
                countDate:'',
                areaCode: localStorage.getItem('tenantAreaCode')
            };
        },
        computed:{
        },
        watch: {
            areaCode: function () {
                this.getPageData();
            },
        },
        created(){
            this.$route.query.areaCode && (this.areaCode = this.$route.query.areaCode)
        },
        mounted(){
            //引入echarts 初始化图标
            let echarts = require('echarts');
            // 培训情况分析
            this.trainPie = echarts.init(this.$refs.trainPie);
            this.trainLine = echarts.init(this.$refs.trainLine);
            //初始化 setOption
            this.initChart();
            //获取数据
            this.getPageData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // echarts 适应
            resize(){
                this.trainPie.resize();
                this.trainLine.resize();
            },
            initChart(){
                this.trainPie.setOption(
                    {
                        title:{
                            textStyle:{
                                color: '#999999',
                                fontSize:13,
                                fontWeight:400
                            },
                            textAlign:'center',
                            right:'10%',
                            bottom: 40,
                            text: '总数: 0',
                        },
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'10%',
                            left:'center',
                            icon:'circle',
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: '{b} : {c} ({d}%)'
                        },
                        color: [ '#3399FF','#61DDAA','#65789B','#F6BD16'],
                        series: [
                            {
                                type: 'pie',
                                center: ['50%', '43%'],
                                radius:['40%', '65%'],
                                label:{
                                    show:true,
                                    formatter:(params)=>{
                                        return `${params.name}: ${params.percent}%`
                                    }
                                },
                                itemStyle: { //图形样式
                                    normal: {
                                        borderColor: '#ffffff',
                                        borderWidth: 2,
                                    },
                                },
                                data:[{"name":"安全教育","value":"0"},{"name":"进场教育","value":"0"},{"name":"退场教育","value":"0"},{"name":"技能培训","value":"0"}]
                            }
                        ]
                    }
                );
                this.trainLine.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'center',
                            icon:'rect',
                        },
                        tooltip: {
                            // trigger: 'item',
                            // formatter: '{a}\n {b}: {c}',
                            trigger: 'axis',
                        },
                        grid:{
                            left: 60,
                            right:30,
                            top: 40,
                            // bottom: 5,
                        },
                        xAxis:{
                            name:'月份',
                            nameTextStyle:{
                                align:'right',
                                padding:[30,30,0,0]
                            },
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data:[],
                        },
                        yAxis:{
                            name:'单位: 个',
                            nameTextStyle:{
                                align:'left',
                                // padding:[0]
                            },
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                }
                            },
                            axisLine:{
                                show: false
                            },
                            minInterval: 1,
                        },
                        color: [ '#3399FF'],
                        series: [
                            {
                                type: 'line',
                                name: '项目总数',
                                areaStyle: {
                                    opacity:0.4
                                },
                                data:[],
                            },
                            {
                                type: 'line',
                                name: '培训项目数',
                                areaStyle: {
                                    opacity:0.4
                                },
                                data:[],
                            },
                        ]
                    }
                );
            },
            // 统计时间改变
            onCountDate(e){
                this.countDate=e;
                this.querySummaryEducationStatistics();
                this.querySummaryEducationList();
            },
            // 已培训 未培训
            handleTrain(value){
                this.isTraining=value;
                this.page_t=1;
                this.querySummaryEducationList();
            },
            // 页码数改变
            changePage_t(value){
                this.page_t=value;
                this.querySummaryEducationList();
            },
            // /已培训/未培训列表
            querySummaryEducationList(){
                this.loading_t=true;
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryEducationList',
                    data:{
                        isTraining:this.isTraining,
                        countDate:this.countDate,
                        size:10,
                        current:this.page_t,
                        areaCode:this.areaCode,
                    }
                }).then( (response)=> {
                    this.loading_t=false;
                    if (response.data.success){
                        this.total_t = response.data.data.total;
                        this.trainData=response.data.data.records;
                    }
                }).catch(()=>{
                    this.loading_t=false;
                });
            },
            // 培训情况分析
            querySummaryEducationStatistics(){
                this.trainPie.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryEducationStatistics',
                    data:{
                        areaCode:this.areaCode,
                        countDate:this.countDate,
                    }
                }).then( (response)=> {
                    this.trainPie.hideLoading();
                    if (response.data && response.data.length){
                        this.trainPie.setOption(
                            {
                                title:{
                                    text: '总数: '+ response.data[4].value,
                                },
                                legend:{
                                    // 使用回调函数
                                    formatter: function (name) {
                                        let val=response.data.filter(item=>{
                                            return item.name===name;
                                        })[0].value || 0;
                                        return name + val;
                                    }
                                },
                                color:[ '#3399FF','#61DDAA','#65789B','#F6BD16'],
                                series: [
                                    {
                                        data:response.data.slice(0,-1)
                                    }
                                ]
                            }
                        );
                    }
                });
            },
            // 年份改变
            onDateYear(e){
                this.dateYear=e;
                this.querySummaryEducationCount();
            },
            // 培训情况开展统计
            querySummaryEducationCount(){
                this.trainLine.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryEducationCount',
                    data:{
                        areaCode:this.areaCode,
                        year:this.dateYear,
                    }
                }).then( (response)=> {
                    this.trainLine.hideLoading();
                    if (response.data){
                        let xData=[];
                        response.data.totalProject.forEach(item=>{
                            xData.push(item.name+'月')
                        });
                        this.trainLine.setOption(
                            {
                                xAxis:{
                                    data:xData,
                                },
                                color: [ '#52C1F5','#4BCED0'],
                                series: [
                                    {
                                        data:response.data.totalProject,
                                    },
                                    {
                                        data:response.data.eduProject,
                                    },
                                ]
                            }
                        );
                    }
                });
            },
            /* 获取页面数据 */
            getPageData(){
                this.querySummaryEducationStatistics();
                this.querySummaryEducationList();
                this.querySummaryEducationCount();
            },
        }
    };
</script>
